<template>
  <v-col
    cols="12"
    :md="item.layout || 12"
    class="pa-2 form-column"
    v-if="item.type.toLowerCase() != 'group'"
  >
    <!-- TEXT FIELD -->
    <v-text-field
      v-if="item.type.toLowerCase() == 'text'"
      v-model="fieldValue"
      :label="item.label"
      :name="item.name"
      :required="item.required"
      :dense="dense"
      hide-details="auto"
    ></v-text-field>
    <!-- EMAIL FIELD -->
    <v-text-field
      v-if="item.type.toLowerCase() == 'email'"
      v-model="fieldValue"
      :rules="emailRules"
      :label="item.label"
      :name="item.name"
      :dense="dense"
      :required="item.required"
      hide-details="auto"
    ></v-text-field>
    <!-- PHONE FIELD -->
    <v-text-field
      v-if="item.type.toLowerCase() == 'phone'"
      v-model="fieldValue"
      :label="item.label"
      :name="item.name"
      :dense="dense"
      :required="item.required"
      hide-details="auto"
    ></v-text-field>
    <!-- DIVIDER -->
    <div v-if="item.type.toLowerCase() == 'divider'">
      <h3>{{ item.label }}</h3>
      <v-divider></v-divider>
    </div>
    <!-- COUNTRY -->
    <v-autocomplete
      v-if="item.type.toLowerCase() == 'country'"
      v-model="fieldValue"
      :loading="countryLoading"
      :items="country.items"
      :search-input.sync="country.search"
      color="blue-grey lighten-2"
      :label="item.label"
      name="Country"
      persistent-placeholder
      :placeholder="item.label"
      flat
      :dense="dense"
    >
    </v-autocomplete>

    <!-- #region SELECTION OPTIONS -->
    <!-- SELECT DROPDOWN -->
    <v-select
      :dense="dense"
      v-if="item.type.toLowerCase() == 'select'"
      :label="item.label"
      :name="item.name"
      v-model="fieldValue"
      :items="_options(item.options)"
      required
    ></v-select>
    <!-- SELECT DROPDOWN AUTOCOMPLETE -->
    <v-autocomplete
      v-if="item.type.toLowerCase() == 'select:autocomplete'"
      v-model="fieldValue"
      :items="_options(item.options)"
      :name="item.name"
      :dense="dense"
      :label="item.label"
    ></v-autocomplete>
    <!-- #endregion  -->
    <!-- FILE INPUT -->
    <v-file-input
      :dense="dense"
      v-if="item.type.toLowerCase() == 'image'"
      accept="image/*"
      :label="item.label"
      :name="item.name"
    ></v-file-input>
    <!-- DATE INPUT -->
    <v-menu
      v-if="item.type.toLowerCase() == 'date'"
      v-model="date.menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      :nudge-left="20"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :dense="dense"
          v-model="fieldValue"
          :name="item.name"
          :label="item.label"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        no-title
        v-model="fieldValue"
        @input="date.menu = false"
      ></v-date-picker>
    </v-menu>
    <!-- CHECKBOX  -->
    <v-checkbox
      v-if="item.type.toLowerCase() == 'checkbox'"
      v-model="fieldValue"
      :label="item.label"
      :dense="dense"
      :name="item.name"
    ></v-checkbox>
  </v-col>
</template>

<script>
export default {
  name: "FormFields",
  props: {
    value: {
      default: null,
    },
    item: {
      type: Object,
    },
  },
  data() {
    return {
      dense: true,
      fieldValue: null,
      dataMenu: null,
      date: {
        menu: false,
        model: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      },
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      render: true,
      country: {
        search: "",
        items: [
          "Afghanistan",
          "Albania",
          "Algeria",
          "Andorra",
          "Angola",
          "Antigua and Barbuda",
          "Argentina",
          "Armenia",
          "Australia",
          "Austria",
          "Azerbaijan",
          "The Bahamas",
          "Bahrain",
          "Bangladesh",
          "Barbados",
          "Belarus",
          "Belgium",
          "Belize",
          "Benin",
          "Bhutan",
          "Bolivia",
          "Bosnia and Herzegovina",
          "Botswana",
          "Brazil",
          "Brunei",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Cabo Verde",
          "Cambodia",
          "Cameroon",
          "Canada",
          "Central African Republic",
          "Chad",
          "Chile",
          "China",
          "Colombia",
          "Comoros",
          "Congo, Democratic Republic of the",
          "Congo, Republic of the",
          "Costa Rica",
          "Côte d’Ivoire",
          "Croatia",
          "Cuba",
          "Cyprus",
          "Czech Republic",
          "Denmark",
          "Djibouti",
          "Dominica",
          "Dominican Republic",
          "East Timor (Timor-Leste)",
          "Ecuador",
          "Egypt",
          "El Salvador",
          "Equatorial Guinea",
          "Eritrea",
          "Estonia",
          "Eswatini",
          "Ethiopia",
          "Fiji",
          "Finland",
          "France",
          "Gabon",
          "The Gambia",
          "Georgia",
          "Germany",
          "Ghana",
          "Greece",
          "Grenada",
          "Guatemala",
          "Guinea",
          "Guinea-Bissau",
          "Guyana",
          "Haiti",
          "Honduras",
          "Hungary",
          "Iceland",
          "India",
          "Indonesia",
          "Iran",
          "Iraq",
          "Ireland",
          "Israel",
          "Italy",
          "Jamaica",
          "Japan",
          "Jordan",
          "Kazakhstan",
          "Kenya",
          "Kiribati",
          "Korea, North",
          "Korea, South",
          "Kosovo",
          "Kuwait",
          "Kyrgyzstan",
          "Laos",
          "Latvia",
          "Lebanon",
          "Lesotho",
          "Liberia",
          "Libya",
          "Liechtenstein",
          "Lithuania",
          "Luxembourg",
          "Madagascar",
          "Malawi",
          "Malaysia",
          "Maldives",
          "Mali",
          "Malta",
          "Marshall Islands",
          "Mauritania",
          "Mauritius",
          "Mexico",
          "Micronesia, Federated States of",
          "Moldova",
          "Monaco",
          "Mongolia",
          "Montenegro",
          "Morocco",
          "Mozambique",
          "Myanmar (Burma)",
          "Namibia",
          "Nauru",
          "Nepal",
          "Netherlands",
          "New Zealand",
          "Nicaragua",
          "Niger",
          "Nigeria",
          "North Macedonia",
          "Norway",
          "Oman",
          "Pakistan",
          "Palau",
          "Panama",
          "Papua New Guinea",
          "Paraguay",
          "Peru",
          "Philippines",
          "Poland",
          "Portugal",
          "Qatar",
          "Romania",
          "Russia",
          "Rwanda",
          "Saint Kitts and Nevis",
          "Saint Lucia",
          "Saint Vincent and the Grenadines",
          "Samoa",
          "San Marino",
          "Sao Tome and Principe",
          "Saudi Arabia",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leone",
          "Singapore",
          "Slovakia",
          "Slovenia",
          "Solomon Islands",
          "Somalia",
          "South Africa",
          "Spain",
          "Sri Lanka",
          "Sudan",
          "Sudan, South",
          "Suriname",
          "Sweden",
          "Switzerland",
          "Syria",
          "Taiwan",
          "Tajikistan",
          "Tanzania",
          "Thailand",
          "Togo",
          "Tonga",
          "Trinidad and Tobago",
          "Tunisia",
          "Turkey",
          "Turkmenistan",
          "Tuvalu",
          "Uganda",
          "Ukraine",
          "United Arab Emirates",
          "United Kingdom",
          "United States",
          "Uruguay",
          "Uzbekistan",
          "Vanuatu",
          "Vatican City",
          "Venezuela",
          "Vietnam",
          "Yemen",
          "Zambia",
          "Zimbabwe",
        ],
      },

      panels: {}, // expansion panels if
    };
  },
  computed: {
    countryLoading() {
      if (this.country.search) {
        return this.country.search.length == 0;
      }
    },
  },
  methods: {
    _options(string) {
      //converts csv to array
      string = string.split(",");
      return string.map((item) => item.trim());
    },
    reRender() {
      this.render = false;
      this.$nextTick(() => {
        this.render = true;
      });
    },
  },
  watch: {
    fieldValue: {
      // if lazy is set to false it will update v-model right away
      deep: true,
      handler(newVal, oldVal) {
        if (oldVal) {
          console.log("formfield watch", newVal, oldVal);
          this.$emit("input", newVal);
        }
      },
    },
    // "country.search": {
    //   deep: true,
    //   handler(val) {
    //     val && val !== this.select && this.querySelections(val);
    //   },
    // },
  },
  mounted() {
    this.fieldValue = this.value;
  },
};
</script>

<style>
.v-autocomplete__content {
  z-index: 99999 !important;
}
.form-column {
  z-index: 99999;
}
</style>
